import React from "react";
import styled from "styled-components";

const SvgContainer = styled.svg`
  height: 1.2rem;
  color: ${(p) => p.color || p.theme.color.primary};
`;

const NotCheckedSvg = (props) => (
  <SvgContainer xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    {/* <title>ico_</title> */}
    <rect
      x="1.5"
      y="1.5"
      width="25"
      height="25"
      rx="3.5"
      fill="#F1F1F1"
      // fillOpacity="0.2"
    />
    <path
      fill="#F1F1F1"
      // d="M23,2a3.00339,3.00339,0,0,1,3,3V23a3.00339,3.00339,0,0,1-3,3H5a3.00339,3.00339,0,0,1-3-3V5A3.00339,3.00339,0,0,1,5,2H23m0-1H5A4,4,0,0,0,1,5V23a4,4,
      // 0,0,0,4,4H23a4,4,0,0,0,4-4V5a4,4,0,0,0-4-4Z"
    />
  </SvgContainer>
);

export default NotCheckedSvg;
